import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });
export const authApi = axios.create({ baseURL: API, withCredentials: true });

export function getSessionId() {
  let id = localStorage.getItem("psh_chat_session");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("psh_chat_session", id);
  }
  return id;
}
